import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FieldListItem } from './field-list-item';
import { useShiftKeyPress } from '../hooks';

import style from '../export-records-modal.module.less';

export const AvailableFieldList = ({ availableFields, setAvailableFields }) => {
  const shiftKeyPressed = useShiftKeyPress();
  const [lastClickedFieldId, setLastClickFieldId] = useState();

  const shiftClickAvailableFields = useCallback(
    (fieldId) => {
      const currentAvailableFields = [...availableFields];
      const clickedFieldIndex = currentAvailableFields.findIndex((f) => f.fieldId === fieldId);
      const lastClickedIndex = currentAvailableFields.findIndex((f) => f.fieldId === lastClickedFieldId);
      const [startIndex, endIndex] =
        lastClickedIndex < clickedFieldIndex ? [lastClickedIndex, clickedFieldIndex] : [clickedFieldIndex, lastClickedIndex];
      const updatedFields = currentAvailableFields.map((f, index) => {
        if (index !== lastClickedIndex && index >= startIndex && index <= endIndex) {
          return { ...f, wasClicked: !f.wasClicked };
        }
        return f;
      });
      setAvailableFields(updatedFields);
    },
    [availableFields, lastClickedFieldId, setAvailableFields],
  );

  const onAvailableFieldItemClicked = useCallback(
    (fieldId) => {
      setLastClickFieldId(fieldId);
      if (shiftKeyPressed) {
        shiftClickAvailableFields(fieldId);
        return;
      }
      const updatedFields = availableFields.map((f) => {
        if (f.fieldId === fieldId) {
          return {
            ...f,
            wasClicked: !f.wasClicked,
          };
        }
        return f;
      });
      setAvailableFields(updatedFields);
    },
    [availableFields, shiftKeyPressed, shiftClickAvailableFields, setAvailableFields],
  );
  return (
    <ul>
      {availableFields.map((field) => {
        return (
          <FieldListItem
            key={field.fieldId}
            classNames={classnames({ [style.active]: field.wasClicked }, { [style.hidden]: field.isHidden })}
            fieldId={field.fieldId}
            fieldName={field.name}
            onClick={onAvailableFieldItemClicked}
          />
        );
      })}
    </ul>
  );
};

AvailableFieldList.propTypes = {
  availableFields: PropTypes.array.isRequired,
  setAvailableFields: PropTypes.func.isRequired,
};
